<template>
  <v-card flat width="400px" class="mx-auto">
    <v-form @submit.prevent="saveUserRegistration()">

      <v-card-title>
        Create a New Account
      </v-card-title>

      <v-card-text>
      <v-text-field
        label="Email Address"
        type="email"
        name="email"
        autocomplete="email"
        v-model="email"
        ref="email"
        :disabled="sending"
        :rules="rules.email"
        @keyup="verifyEmail(email)"
        @input="verifyEmail(email)"
        color="grey"
        :append-icon="isEmailAvalible == null ? '' : isEmailAvalible ? 'mdi-account-check' : 'mdi-account-alert'"
      />

      <v-text-field
        label="Username (optional)"
        v-model="username" 
        :disabled="sending"
        :rules="rules.username"
        @keyup="verifyUsername(username)"
        :append-icon="isUsernameAvailable == null ? '' : isUsernameAvailable ? 'mdi-account-check' : 'mdi-account-alert'"
      />
        
      <v-text-field
        label="Password"
        v-model="password"
        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
        @click:append="showPassword = !showPassword"
        :type="showPassword ? 'text' : 'password'"
        :disabled="sending"
        :rules="rules.password"
      />
      </v-card-text>            
      
      <v-card-actions class="justify-end">
        <v-btn
          type="submit"
          class="md-raised"
          :disabled="!isGood"
          elevation="0"
          color="primary"
        >Register & Login</v-btn>
      </v-card-actions>

    </v-form>
  </v-card>
</template>

<script>
export default {
  data(){
    return {
      isEmailAvalible: null,
      isUsernameAvailable: null,
      showPassword: false,
      username: null,
      password: null,
      email: null,
      email_available: null,
      userSaved: false,
      sending: false,
      lastUser: null,
      rules: {
        email: [
          v => !!v || 'E-mail is required',
          v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
        ],
        username: [
          v => !v || (!!v && v.length >= 3) || 'Username is too short...',
        ],
        password: [
          v => !!v || 'E-mail is required',
          v => (!!v && v.length >= 4) || 'Password is too short...',
        ]
      }
    }
  },
  computed: {
    isGood(){
      return this.isEmailAvalible
        && this.password && this.password.length >= 4
        && (this.isUsernameAvailable || !this.username)
    }
  },

  methods: {
    async verifyEmail (v) {
      if (/.+@.+\..+/.test(v)) {
        this.isEmailAvalible = await this.api.get(`/user/email_test/${v}`)
      }
    },
    async verifyUsername (v) {
      if (v && v.length >=3) {
        this.isUsernameAvailable = await this.api.get(`/user/username_test/${v}`)
      }
    },
    saveUserRegistration () {
      if (this.email && this.password) {
        this.sending = true
        window.setTimeout(() => {
          this.register()
          this.lastUser = `${this.email} ${this.username}`
          this.userSaved = true
          this.sending = false
        }, 500)
      }
    },

    async register(){

      let register = await this.api.post('/user/register', {
        email: this.email,
        username: this.username,
        password: this.password,
      })
      if (register.success) {
        let user = await this.api.post('/auth/login',{
          username: this.username || this.email,
          password: this.password,
        })
        if (user.auth) {
          this.$store.dispatch('account/LOGIN', user.auth)
        }
        this.$emit('reset')
      }
    },

    focusInput() {
      this.$refs.email.focus();
    },
  },

  mounted() {
    this.focusInput();
  }
}
</script>
